import React, { useEffect, useState } from 'react';
import { Link, Navigate, useNavigate } from 'react-router-dom';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import DashboardActions from './DashboardActions';
import { getCurrentProfile, clearProfile, cleargid, getTFCgrievances } from '../../actions/profile';
import { getProfileAdmin } from '../../actions/master';
import { TFC_CENTER } from '../../Constant';

import moment from 'moment';

const TFCSelect = ({
  getCurrentProfile, getTFCgrievances, getProfileAdmin,
  clearProfile,
  auth: { user },
  profile: { profile2, gt },
  history
}) => {

  const [formData, setFormData] = useState({
    stfc: '39', ntfc: 'Govt. Polytechnic College, Kilapalur Village, Ariyalur – 621 707.', comment: '', appln: '', sgid: '', sgt: ''
  });

  const { stfc, ntfc, comment, appln, sgid, sgt } = formData;
  const [displaycmts, toggledisplaycmts] = useState(false);

  const navigate = useNavigate();

  const handleDeleteRow = async (i) => {
    // const tobesent = {};
    // tobesent._aid = profile._aid;
    // tobesent.row = i;
    //tobesent.gid = gid;
    //console.log(tobesent);
//    await deletegrievance(tobesent);        
    
  }

  const handleSelectRow = async (i,aid,sgt) => {
    toggledisplaycmts(!displaycmts);
    console.log(i,aid);
    formData.appln = aid;
    formData.sgid = i;
    formData.sgt = sgt;
  }

  const handleEditRow = async (i,aid,sgt) => {    
    console.log(i,aid);
    formData.appln = aid;
    formData.sgid = i;
    formData.sgt = sgt;
    await getProfileAdmin(formData.appln, formData.sgt, history);           
    navigate("/adash");
  }


  const handleSaveRow = async (i) => {
    // const tobesent = {};
    // tobesent._aid = profile._aid;
    // tobesent.row = i;
    //tobesent.gid = gid;
    //console.log(tobesent);
//    await deletegrievance(tobesent);        
    
  }

  const onChange = (e) =>
    setFormData({ ...formData, [e.target.name]: e.target.value });


  const onCodeChange = e => {

    e.preventDefault();

    let temp = e.target.value;
    

    if(e.target.name === "stfc")
    {

      //console.log(TFC_CENTER.filter(e => e.key.toString() === temp.toString()).map(e => e.label)[0]);
      

      formData.ntfc = TFC_CENTER.filter(e => e.key.toString() === temp.toString()).map(e => e.label)[0]

        //formData.stfc = TFC_CENTER.filter(e => e.label.toString().trim() === formData.ntfc.toString().trim()).map(e => e.key)[0];
      
    }
    if(e.target.name === "ntfc")
    {

      //console.log(temp); 
      
        formData.stfc = TFC_CENTER.filter(e => e.label.toString().trim().includes(temp.toString().trim())).map(e => e.key)[0];

        //console.log(formData.stfc);

        //if(formData.stfc !== undefined)
          //formData.ntfc = TFC_CENTER.filter(e => e.key.toString().trim() === formData.stfc.toString().trim()).map(e => e.label)[0];
      
    }

    console.log(formData.stfc, formData.ntfc);

    setFormData({ ...formData, [e.target.name]: e.target.value });

    //this.setState({name: e.target.value});

  }

  const responses = profile2 !== null && profile2 !== undefined && profile2.gr !== undefined && profile2.gr.cmts !== undefined && profile2.gr.cmts.length > 0 && profile2.gr.cmts.map((comment) => (
    <tr key={comment._id}>
        <td>{comment.rep}</td>  
        <td>{comment.rd}</td>          
    </tr>
  ));

  const grievances = profile2 !== null && profile2 !== undefined && profile2.map((edu) => (
    <tr key={edu._aid}>
      <td>{edu._aid}</td>   
      <td>
      {edu.gr.map((pp) => (
        <div className='profile-grid'>
        <table className='table' style={{border: '1px ridge'}}> <tbody>
        <tr key={pp._gid}>          
          <td>{pp.gt}</td>      
          <td>{pp.st}</td>           
          <td> {moment(pp.updated).format('DD/MM/YYYY')} </td>
          <td>
          {((edu.gups !== undefined && edu.gups !== null) && edu.gups.filter((item => (item._gid === pp._gid)))).map((chk) => (
            <a key={chk._gid} href={chk.l} target="_blank" rel="noopener noreferrer" > Download Request Letter </a>
          ))}
          
          </td>     
          <td>
          {((edu.cmts !== undefined && edu.cmts !== null) && edu.cmts.filter((item => (item._gid === pp._gid)))).map((chk) => (
            <div key={chk._gid}>{chk.adm} : {chk.rep} : {chk.rd}</div>
          ))}
          </td>     
         
          <td> <button className="btn btn-light" onClick={i => handleSelectRow(pp._gid, edu._aid, pp.gt)} > comment </button> </td>

          <td> <button className="btn btn-light" onClick={i => handleEditRow(pp._gid, edu._aid, pp.gt)} > Edit </button> </td>

        </tr>  </tbody>
        </table>
        </div>
      ))}
      </td>
    </tr>
  ));

  const clearNext = async() => {
    //clearProfile(history, "3");   
    await clearProfile();
    await getTFCgrievances(formData.stfc);
  }

  return (
    <section className="container">
      {/* <h1 className="large text-primary">{user.tfcname}</h1> */}

      <h4> Grievance System - Admin </h4>
      <p className="lead">
        <i className="fas fa-list" /> Select TFC Center to View Grievances
      </p>

                <div className="form" >   
                    <div className='form-group'>
                      <label className="form-text" htmlFor="stfc">
                        TFC Code
                        </label>   
                        
                        <select name="stfc" value={stfc} onChange = {e => onCodeChange(e) }>                             
                            {TFC_CENTER.map(e => <option key={e.key}> {e.key} </option>) }
                        </select>
                    </div>
    
                    <div className='form-group'>
                    <label className="form-text" htmlFor="ntfc">
                        TFC Name
                    </label>   
                    <select name="ntfc" value={ntfc} onChange = {e => onCodeChange(e)} 
                        style={{textOverflow: "ellipsis", overflow: "hidden"}}>                             
                            {TFC_CENTER.map(e => <option key={e.key}> {e.label} </option>) }
                    </select>
                    </div>

                

      {/* <div style={{textAlign: "right"}}>
      <button
          onClick={() => cclearProfile()}
          className="btn btn-light" style={{alignItems: "right"}}
        >
          Clear Search
      </button>
      </div> */}
      <br />

        <div className='form-group'>
          <input type="submit" className='btn btn-dark'  value="Submit" onClick= {e => clearNext(e)} />    
          </div>
        </div>

        {profile2 !== null && profile2 !== undefined && 
      <>
          <h3 className="my-2">Grievances List </h3>
          <div className='profile-grid'>
          <table className="table" style={{border: '1px ridge'}}>
            <thead>
              <tr>
                <th>Application number</th>
                <tr>
                  <td>
                <table className="table" style={{textAlign: "right"}}>
                  <thead>
                    <tr>
                <th>Description</th>
                <th >Status</th>
                <th >Date</th>
                
                <th >Request Letter</th>
                <th >Admin response</th>
                
                </tr>
                </thead>
                </table>
                </td>
                </tr>
                
              </tr>
            </thead>
            <tbody>{grievances}</tbody>
          </table>
          </div>
      </>
      }      

        {displaycmts && (
          
          <div className='profile form'>
            <h4> Selected Grievance: <br/> {appln} - {sgt} </h4>
               
                <input
                  type="text"
                  placeholder="*Enter comments"
                  name="comment"
                  value={comment}
                  onChange={onChange}
                  required
                />
          
              <input type="submit" className='btn btn-light'  value="save" onClick={() => handleSaveRow()} />  
          
          </div>
          )}

    </section>
  );
};

TFCSelect.propTypes = {
  getCurrentProfile: PropTypes.func.isRequired,
  getTFCgrievances: PropTypes.func.isRequired,
  getProfileAdmin: PropTypes.func.isRequired,

  clearProfile: PropTypes.func.isRequired,
  cleargid: PropTypes.func.isRequired,
  auth: PropTypes.object.isRequired,
  profile: PropTypes.object.isRequired
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  profile: state.profile
});

export default connect(mapStateToProps, { getCurrentProfile, clearProfile, cleargid, getTFCgrievances,
getProfileAdmin })(
  TFCSelect
);
